import { useParams, useNavigate } from 'react-router-dom';
import PanelContent from '@shared/components/PanelContent';
import OrderDetail from './components/OrderDetail';

export default function OrderDetailPage() {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();

  if (!orderId) return null;

  return (
    <PanelContent>
      <div data-testid="page-orders-detail">
        <OrderDetail orderId={orderId} onBack={() => void navigate('/orders')} />
      </div>
    </PanelContent>
  );
}
